/**
 * useLocalStorage Hook
 * @module useLocalStorage
 */

let CODE = 'ACQ';

/**
 * @function
 * Set CODE('ACQ','CO','CS') in localstorage.
 * @param {string} type - attribute name
 * @returns {void} - attribute value
 */

export const setCode = type => {
  CODE = type;
};

/**
 * @function
 * Get item from localstorage.
 * @param {string} key - attribute name
 * @returns {string} - attribute value
 */
export const getLocalStorage = key => {
  try {
    return localStorage.getItem(`${CODE}_${key}`.toUpperCase());
  } catch (e) {
    return null;
  }
};

/**
 * @function
 * Set item in localstorage.
 * @param {string} key - attribute name
 * @param {string} value - attribute name
 * @returns {void} - attribute value
 */
export const setLocalStorage = (key, value) => {
  localStorage.setItem(`${CODE}_${key}`.toUpperCase(), value);
};

/**
 * @function
 * Remove an item from localstorage.
 * @param {string} key - attribute name
 * @returns {void} - attribute value
 */
export const removeLocalStorage = key => localStorage.removeItem(`${CODE}_${key}`.toUpperCase());

/** To remove  all the values from local storage based on CODE */
export const clearLocalStorage = () => {
  Object.keys(localStorage).forEach(key => key.startsWith(CODE) && localStorage.removeItem(key));
};

/** To remove  all the values from local storage based on journey */

export const clearJourneyLocalStorage = journeyCode => {
  Object.keys(localStorage).forEach(
    key => key.startsWith(journeyCode) && localStorage.removeItem(key)
  );
};
/**
 * @function
 * To compare an item from localstorage. Both key and value required.
 *
 * To check if an item exists.
 * Only key required.
 * @param {string} key - attribute name
 * @param {string} [value] - value to compare with the value in localstorage
 * @returns {void} - attribute value
 */
export const hasValue = (key, value) => {
  if (value) {
    return getLocalStorage(key) === value;
  }
  return Boolean(getLocalStorage(key));
};

export const getLocalStorageWithPrefix = key => {
  try {
    return localStorage.getItem(key.toUpperCase());
  } catch (e) {
    return null;
  }
};
export const setLocalStorageWithPrefix = (key, value) => {
  localStorage.setItem(key.toUpperCase(), value);
};

export const removeLocalStorageWithPrefix = key => localStorage.removeItem(key.toUpperCase());

export const hasLocalStorageValue = (key, value) => {
  if (value) {
    return getLocalStorageWithPrefix(key) === value;
  }
  return Boolean(getLocalStorageWithPrefix(key));
};

/**
 * @function
 * Hook to store, remove or get localstorage items.
 * @returns - {getLocalStorage, setLocalStorage, removeLocalStorage, hasValue,clearLocalStorage,setCode}
 */
export default function useLocalStorage() {
  return {
    getLocalStorage,
    setLocalStorage,
    removeLocalStorage,
    hasValue,
    clearLocalStorage,
    setCode,
    getLocalStorageWithPrefix,
    setLocalStorageWithPrefix,
    removeLocalStorageWithPrefix,
    hasLocalStorageValue,
    clearJourneyLocalStorage,
  };
}
